import axios from 'axios';
import { CLEAR_CLIENT_PAYMENT_TOKEN, GET_CLIENT_PAYMENT_TOKEN } from '../actionTypes';
import { showAlert } from './alert';
import { hideLoader, showLoader } from './loader';

const SERVICE = 'payments';

export const getPaymentToken = isUpdatePaymentMethods => dispatch => {
	dispatch({
		type: CLEAR_CLIENT_PAYMENT_TOKEN,
		payload: '',
	});
	let req = {};
	let url = `${SERVICE}/getClientToken`;
	if (isUpdatePaymentMethods) {
		url = `${SERVICE}/getClientToken`;
	}
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		dispatch(showLoader());
		axios
			.get(url, req)
			.then(res => {
				dispatch(hideLoader());
				dispatch({
					type: GET_CLIENT_PAYMENT_TOKEN,
					payload: res.data.token,
				});
			})
			.catch(err => {
				dispatch(hideLoader());
				if (err.response) {
					dispatch(showAlert(err.response.data.error.message, true));
				}
				reject(err);
			});
	});
};

export const getSubscriptionPlans = isUpdatePaymentMethods => dispatch => {
	let req = {};
	let url = `/subscriptionPlans`;
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		dispatch(showLoader());
		axios
			.get(url, req)
			.then(res => {
				dispatch(hideLoader());
				response(res.data)
			})
			.catch(err => {
				dispatch(hideLoader());
				reject(err);
			});
	});
};


export const getGateWayDashBoardLink = () => dispatch => {
	let url = `${SERVICE}/getGateWayDashBoardLink`;
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		dispatch(showLoader());
		axios
			.post(url, {})
			.then(res => {
				dispatch(hideLoader());
				response(res);
			})
			.catch(e => {
				dispatch(hideLoader());
				if (e.response) {
					dispatch(showAlert(e.response.data.error.message, true));
				}
				reject(e);
			});
	});
};

export const updateCard = card => dispatch => {
	return new Promise((response, reject) => {
		dispatch(showLoader());
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post(`${SERVICE}/updateCard`, card)
			.then(res => {
				dispatch(hideLoader());
				dispatch(showAlert(res.data.message));
				response(res.data);
			})
			.catch(err => {
				dispatch(hideLoader());
				if (err.response) {
					dispatch(showAlert(err.response.data.error.message, true));
				}
				reject();
			});
	});
};


export const updateBrandSubscription = card => dispatch => {
	return new Promise((response, reject) => {
		dispatch(showLoader());
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post(`users/brandMembership`, card)
			.then(res => {
				dispatch(hideLoader());
				dispatch(showAlert(res.data.message));
				response(res.data);
			})
			.catch(err => {
				dispatch(hideLoader());
				if (err.response) {
					dispatch(showAlert(err.response.data.error.message, true));
				}
				reject();
			});
	});
};


// WEBPACK FOOTER //
// ./src/store/actions/payments.js